import { Controller } from "@hotwired/stimulus";

// Manages the inbox expand/collapse in the sidebar.
// Supports both manual toggle (click) and automatic detection based on URL.
export default class extends Controller {
  static targets = ["parent", "children"];

  connect() {
    this.update();
  }

  toggle(event) {
    event.preventDefault();
    if (!this.hasChildrenTarget) return;

    const expanded = this.childrenTarget.classList.contains("hidden");
    this.childrenTarget.classList.toggle("hidden");

    if (this.hasParentTarget) {
      this.parentTarget.setAttribute("aria-expanded", String(expanded));
      if (expanded) {
        this.parentTarget.classList.add(
          "bg-gray-100", "text-gray-900",
          "dark:bg-gray-800", "dark:text-white"
        );
      } else {
        this.parentTarget.classList.remove(
          "bg-gray-100", "text-gray-900",
          "dark:bg-gray-800", "dark:text-white"
        );
      }
    }

    if (expanded) {
      this.highlightActiveChannel();
    } else {
      this.clearActiveChannel();
    }
  }

  update() {
    const onInbox = window.location.pathname.match(/\/inbox/);
    const parentEl = this.hasParentTarget ? this.parentTarget : null;
    const childrenEl = this.hasChildrenTarget ? this.childrenTarget : null;

    if (!childrenEl) return;

    if (onInbox) {
      // Auto-expand and highlight when on any inbox page
      childrenEl.classList.remove("hidden");
      if (parentEl) {
        parentEl.classList.add(
          "bg-gray-100", "text-gray-900",
          "dark:bg-gray-800", "dark:text-white"
        );
        parentEl.setAttribute("aria-expanded", "true");
      }
      this.highlightActiveChannel();
    } else {
      // Not on inbox — clear highlights but leave toggle state alone
      if (parentEl) {
        parentEl.classList.remove(
          "bg-gray-100", "text-gray-900",
          "dark:bg-gray-800", "dark:text-white"
        );
      }
      this.clearActiveChannel();
    }
  }

  highlightActiveChannel() {
    if (!this.hasChildrenTarget) return;

    const params = new URLSearchParams(window.location.search);
    const channel = params.get("channel");

    const links = this.childrenTarget.querySelectorAll("a");
    links.forEach((link) => {
      link.removeAttribute("aria-current");
      link.classList.remove(
        "bg-gray-100", "text-gray-900",
        "dark:bg-gray-800", "dark:text-white"
      );
    });

    if (channel) {
      const activeLink = this.childrenTarget.querySelector(
        `a[href$="channel=${channel}"]`
      );
      if (activeLink) {
        activeLink.setAttribute("aria-current", "page");
        activeLink.classList.add(
          "bg-gray-100", "text-gray-900",
          "dark:bg-gray-800", "dark:text-white"
        );
      }
    }
  }

  clearActiveChannel() {
    if (!this.hasChildrenTarget) return;

    const links = this.childrenTarget.querySelectorAll("a");
    links.forEach((link) => {
      link.removeAttribute("aria-current");
      link.classList.remove(
        "bg-gray-100", "text-gray-900",
        "dark:bg-gray-800", "dark:text-white"
      );
    });
  }
}
